import { takeLatest } from 'redux-saga/effects';

import { getAccountPath } from '../../utils/firebase';
import { fetchSaga } from './helper';
import { fetchTaskFileConfigsRoutine } from '../routines';

function* watchFetchTaskFileConfigsSaga() {
  yield takeLatest(fetchTaskFileConfigsRoutine.TRIGGER, fetchSaga(fetchTaskFileConfigsRoutine, () => getAccountPath('/taskfileconfigs')));
}

export {
  watchFetchTaskFileConfigsSaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/taskfileconfigs.js